import type { DetailedHTMLProps, FunctionComponent, InputHTMLAttributes, ReactNode } from 'react'
import style from './Form.module.sass'

type TextInputProps = {
	label?: string
	type: string
	id?: string
	key?: string
	icon?: ReactNode
} & Pick<
	DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
	| 'autoComplete'
	| 'minLength'
	| 'onFocus'
	| 'onChange'
	| 'value'
	| 'defaultValue'
	| 'required'
	| 'name'
	| 'placeholder'
	| 'onBlur'
	| 'onPaste'
	| 'onCopy'
>

export const TextInput: FunctionComponent<TextInputProps> = ({
	label,
	placeholder,
	name,
	type,
	key,
	defaultValue,
	onPaste,
	onCopy,
	value,
	required = false,
	onChange,
	onBlur,
	onFocus,
	icon,
	minLength,
	autoComplete,
	id,
}) => {
	if (typeof window !== 'undefined') {
		window.onload = () => {
			if (id) {
				const input = document.getElementById(id) as HTMLElement
				if (input) {
					input.onpaste = (e) => e.preventDefault()
				}
			}
		}
	}

	return (
		<div className={style.inputWrapper}>
			<label className={style.inputLabelWrapper}>
				<div className={style.inputLabel}>{label}</div>
				<input
					key={key}
					type={type}
					id={id}
					required={required}
					name={name}
					onPaste={onPaste}
					onFocus={onFocus}
					onCopy={onCopy}
					className={style.input}
					placeholder={placeholder}
					defaultValue={defaultValue}
					value={value}
					onBlur={onBlur}
					onChange={onChange}
					minLength={minLength}
					autoComplete={autoComplete}
				/>
				{icon && <span className={style.textInputIcon}>{icon}</span>}
			</label>
		</div>
	)
}
